module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraLight.eb32bc3.woff2";